(() => {
  const initialize = () => {
    const root = document.querySelector('product-info[data-rl-layout]');
    if (!root || root.dataset.rlStickyReady) return;
    const sticky = root.querySelector('.sh-sticky-atc');
    const button = sticky?.querySelector('button');
    const price = sticky?.querySelector('.sh-sticky-atc__price');
    const size = sticky?.querySelector('.sh-sticky-atc__size');
    if (!sticky || !button) return;
    root.dataset.rlStickyReady = 'true';
    let selected = false;
    let needsSizeSelection = false;
    let highlightAllowed = false;
    let highlightPending = false;
    let highlightCleanup;
    const colorLinks = Array.from(root.querySelectorAll('.rl-color-switch__option'));
    const colorUrls = new Map(colorLinks.map(link => [link, link.href]));
    const updateColorLinks = value => {
      colorLinks.forEach(link => {
        const url = new URL(colorUrls.get(link));
        // Size labels are shared across colors; variant IDs are not. The
        // destination resolves the label through its own native variant select.
        url.searchParams.delete('variant');
        url.searchParams.delete('option_values');
        if (selected && value) url.searchParams.set('rl_size', value);
        else url.searchParams.delete('rl_size');
        link.href = url.href;
      });
    };
    const update = () => {
      const nativeButton = root.querySelector('.product-form__submit');
      const selectedInput = root.querySelector('variant-selects select')?.selectedOptions[0] || root.querySelector('variant-selects input:checked');
      const value = selectedInput?.value || '';
      updateColorLinks(value);
      const priceSource = root.querySelector('.sh-main-price .price-item--sale') || root.querySelector('.sh-main-price .price-item--regular');
      if (priceSource) price.textContent = priceSource.textContent.trim();
      size.textContent = selected ? value : '';
      button.disabled = selected && !!nativeButton?.disabled;
      button.textContent = !selected ? button.dataset.chooseSize : nativeButton?.disabled ? nativeButton.textContent.trim() : button.dataset.addToCart;
      highlightWhenReady();
    };
    const highlightWhenReady = () => {
      const nativeButton = root.querySelector('.product-form__submit');
      if (!highlightPending || !nativeButton || nativeButton.disabled ||
          nativeButton.getAttribute('aria-disabled') === 'true' ||
          nativeButton.classList.contains('loading')) return;
      highlightPending = false;
      // Reuse Salomon's existing 0.6-second pulse and two-second halo.
      nativeButton.classList.remove('sh-atc-highlight');
      void nativeButton.offsetWidth;
      nativeButton.classList.add('sh-atc-highlight');
      highlightCleanup = setTimeout(() => nativeButton.classList.remove('sh-atc-highlight'), 2000);
    };
    const confirmSelection = () => {
      selected = true;
      needsSizeSelection = false;
      root.querySelector('[data-rl-color-size-notice]')?.remove();
      if (highlightAllowed) {
        clearTimeout(highlightCleanup);
        root.querySelector('.product-form__submit')?.classList.remove('sh-atc-highlight');
        highlightPending = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
      update();
    };
    root.addEventListener('rl:size-selected', confirmSelection);
    root.addEventListener('change', event => {
      if (!event.target.closest('variant-selects')) return;
      confirmSelection();
    });
    root.addEventListener('submit', event => {
      if (!needsSizeSelection) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data.sectionId !== root.dataset.section) return;
        if (!event.data.variant?.available) highlightPending = false;
        update();
      });
    }
    const observer = new IntersectionObserver(entries => {
      const visible = !entries[0].isIntersecting;
      sticky.classList.toggle('sh-sticky-atc--visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
    },{threshold:0.1});
    const nativeButton = root.querySelector('.product-form__submit');
    if(nativeButton) observer.observe(nativeButton);
    button.addEventListener('click', () => {
      if (!selected) {
        const picker = root.querySelector('rl-size-picker');
        if (picker?.classList.contains('rl-size-picker--enhanced')) {
          picker.open(undefined, { center: true });
        } else {
          root.querySelector('variant-selects')?.scrollIntoView({behavior:'smooth',block:'center'});
          root.querySelector('variant-selects select, variant-selects input')?.focus({preventScroll:true});
        }
        return;
      }
      const native = root.querySelector('.product-form__submit');
      if(native && !native.disabled) native.click();
    });
    // A color switch can request a sold-out size, but must never silently
    // substitute another size when the requested one does not exist.
    const requestedSize = colorLinks.length && new URL(window.location.href).searchParams.get('rl_size');
    const picker = root.querySelector('rl-size-picker');
    if (requestedSize && picker?.classList.contains('rl-size-picker--enhanced')) {
      const index = Array.from(picker.select.options).findIndex(option => option.value === requestedSize);
      if (index >= 0) {
        picker.choose(index);
      } else {
        selected = false;
        needsSizeSelection = true;
        picker.select.selectedIndex = -1;
        picker.syncSelection();
        const notice = document.createElement('p');
        notice.dataset.rlColorSizeNotice = '';
        notice.setAttribute('role', 'status');
        notice.textContent = root.dataset.rlSizeUnavailable || '';
        picker.after(notice);
        root.querySelector('product-form')?.toggleSubmitButton(true, button.dataset.chooseSize);
        const variantInput = root.querySelector('product-form input[name="id"]');
        if (variantInput) variantInput.value = '';
      }
    }
    // Keep the sticky button disabled while the native variant request runs.
    if (nativeButton) new MutationObserver(update).observe(nativeButton, { attributes: true, childList: true, subtree: true });
    highlightAllowed = true;
    update();
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
